module.exports = __webpack_public_path__ + "static/media/adminScreen.fc5e8891.png";